import React from 'react';
import FortnightRangeControl from '../Transfers/FortnightRangeControl';
import RequirementsTimeline from './RequirementsTimeline';

/**
 * Timeline tab: fortnight navigator + coverage chart only.
 */
const RequirementsTimelineTab = ({
  requirements,
  fortnightIndex,
  setFortnightIndex,
  formattedRangeFortnight,
  anchorFortnightStart,
  fortnightStart,
  fortnightEnd,
}) => {
  return (
    <div className="requirements-timeline-tab">
      <div className="requirements-fortnight-nav d-flex justify-content-center mb-3">
        <FortnightRangeControl
          formattedRangeFortnight={formattedRangeFortnight || '…'}
          fortnightIndex={fortnightIndex}
          setFortnightIndex={setFortnightIndex}
          className="transfers-desktop-fortnight-nav d-flex align-items-center justify-content-center gap-2"
          rangeClassName="transfers-desktop-fortnight-range"
        />
      </div>
      {anchorFortnightStart ? (
        <RequirementsTimeline
          requirements={requirements}
          fortnightIndex={fortnightIndex}
          setFortnightIndex={setFortnightIndex}
          anchorFortnightStart={anchorFortnightStart}
          fortnightStart={fortnightStart}
          fortnightEnd={fortnightEnd}
        />
      ) : (
        <p className="text-muted text-center py-4">Loading fortnight calendar…</p>
      )}
      <p className="text-muted small mt-3 mb-0">
        Bar colour reflects status in the fortnight selected above (centre column). Use the
        Requirements tab for amounts, status, and editing.
      </p>
    </div>
  );
};

export default RequirementsTimelineTab;
